import React, { useState, useEffect, useRef } from 'react';
import './ExpandableDescription.css';

const ExpandableDescription = ({ description, partnerId, proofT }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [needsTruncation, setNeedsTruncation] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => {
    const checkTruncation = () => {
      if (contentRef.current) {
        // Check if mobile viewport
        const isMobile = window.matchMedia('(max-width: 768px)').matches;
        if (!isMobile) {
          setNeedsTruncation(false);
          return;
        }

        const element = contentRef.current;
        
        // Quick check: if description is very short (< 150 chars), likely no truncation needed
        if (description && description.length < 150 && !isExpanded) {
          setNeedsTruncation(false);
          return;
        }
        
        // Remove all truncation classes temporarily to measure full height
        /* eslint-disable no-unused-vars -- reserved for expand/collapse state */
        const hadTruncated = element.classList.contains('truncated');
        const hadExpanded = element.classList.contains('expanded');
        /* eslint-enable no-unused-vars */
        element.classList.remove('truncated', 'expanded');
        void element.offsetHeight; // Force reflow
        
        // Measure full content height
        const fullHeight = element.scrollHeight;
        
        // Now apply truncated class to measure truncated height
        element.classList.add('truncated');
        void element.offsetHeight; // Force reflow
        const truncatedHeight = element.clientHeight;
        
        // Check if content actually exceeds the 3-line limit
        const needsTrunc = fullHeight > truncatedHeight + 5;
        setNeedsTruncation(needsTrunc);
        
        // If expanded, remove truncated; if not expanded and needs truncation, keep it
        if (isExpanded) {
          element.classList.remove('truncated');
          element.classList.add('expanded');
        } else if (needsTrunc) {
          // Keep truncated if needed
          if (!element.classList.contains('truncated')) {
            element.classList.add('truncated');
          }
        } else {
          element.classList.remove('truncated');
        }
      }
    };

    // Use multiple timeouts to ensure DOM is fully rendered
    const timeout1 = setTimeout(() => {
      checkTruncation();
      // Check again after a longer delay to catch any layout shifts
      setTimeout(checkTruncation, 300);
    }, 100);

    // Check on window resize
    window.addEventListener('resize', checkTruncation);

    return () => {
      clearTimeout(timeout1);
      window.removeEventListener('resize', checkTruncation);
    };
  }, [description, isExpanded]);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <>
      <div
        ref={contentRef}
        className={`case-study-content ${!isExpanded ? 'truncated' : 'expanded'}`}
      >
        {description}
      </div>
      {needsTruncation && (
        <button
          className="partner-show-more-btn"
          onClick={toggleExpand}
          aria-label={isExpanded ? proofT('expandable.showLess') : proofT('expandable.showMore')}
        >
          {isExpanded ? proofT('expandable.showLess') : proofT('expandable.showMore')}
        </button>
      )}
    </>
  );
};

export default ExpandableDescription;






